import { useDataAsyncCall } from '~/api/admin-api'
import { convertToServicepointVendor, type ServicepointVendorDto } from '~/modules/servicepointvendors/model'

export const useServicepointVendor = (id: string | undefined) => {
  const [servicepointDto, meta] = useDataAsyncCall<ServicepointVendorDto>(`vendors/${id}`)
  const servicepoint = servicepointDto ? convertToServicepointVendor(servicepointDto) : undefined
  return { servicepoint, isLoading: meta.isLoading }
}
